import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs'

import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogCreaCargaMasiva } from './crear-cargas-masivas.component';
import { CargasMasivasService } from 'src/app/services/cargas-masivas/cargas-masivas.service';

@Component({
  selector: 'app-cargas-masivas',
  templateUrl: '../../pages/cargas-masivas/cargas-masivas.component.html',
  styleUrls: ['../../pages/cargas-masivas/cargas-masivas.component.css']
})
export class CargasMasivasComponent implements OnInit 
{
    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")

    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }

    registros: any 
    registrosFinales: any
    buscador: any = { fecha:'', tipoCarga:'' }
    
    constructor(private dialog: MatDialog, private cargasMasivasService: CargasMasivasService) 
    {         
        //const source = interval(1000)
        
        //source.subscribe(() => this.loadData())
    }

    ngOnInit(): void { this.loadData() }

    loadData() 
    { 
        let vm = this
        
        this.cargasMasivasService.traeCargas().then
        (
            (cargas: any) =>
            {
                console.log(cargas)
                vm.registros = cargas
                vm.registrosFinales = cargas
                
                vm.config.totalItems = cargas.length
            }
        )   
        .catch( error => 
        {
            console.log(error)
            
            vm.openAlertDialog("Ha ocurrido un error en el servicio al traer las cargas masivas.", "btn-danger")    
        })
    }

    buscar()
    {
        if(this.buscador.fecha != '' && this.buscador.tipoCarga != '' ) 
        { 
            this.registrosFinales = this.registros.filter( car => car.fecha == this.buscador.fecha.split('-').reverse().join('-') )
                                   .filter( car => car.tipo == this.buscador.tipoCarga.toUpperCase() )
        }
        else if(this.buscador.fecha != '') 
        { 
            this.registrosFinales = this.registros.filter( car => car.fecha == this.buscador.fecha.split('-').reverse().join('-') )
        }
        else if(this.buscador.tipoCarga != '') 
        { 
            this.registrosFinales = this.registros.filter( car => car.tipo == this.buscador.tipoCarga.toUpperCase() )
        }
        else { this.registrosFinales = this.registros }
        
        this.config.totalItems = this.registrosFinales.length
        this.config.currentPage = 1
    }

    crearCargaMasiva() 
    { 
        let vm = this 
        
        let data: any = { }

        const dialogRef = this.dialog.open(DialogCreaCargaMasiva, { data: data , width: '40%' })

        dialogRef.afterClosed().subscribe( () => 
        { 
            if(data.recarga) 
            {
                vm.loadData()
            } 
        })
    }

    verArchivoCarga(idCarga: any)
    {
        let vm = this

        this.cargasMasivasService.traeArchivoCarga(idCarga).then
        (
            (archivo: ArrayBuffer) =>
            {
                const base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(archivo)));
                const byteCharacters = atob(base64String)
                const byteNumbers = new Array(byteCharacters.length)
                
                for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters.charCodeAt(i) }

                const byteArray = new Uint8Array(byteNumbers)
                const blob = new Blob([byteArray], {type: 'csv'})
                
                var fileURL = URL.createObjectURL(blob)
                //window.open(fileURL)

                var descargar = document.createElement("a");
                descargar.download = idCarga + '.csv';
                descargar.href = fileURL;
                descargar.click();
            }
        )
        .catch ( error =>  
        {
            console.log(error)
            vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
        } )        
    }

    reversarCarga(idCarga: any, tipo: any) 
    { 
        let vm = this

        this.cargasMasivasService.reversaCargas(idCarga, tipo).then
        (
            () => vm.openAlertDialog("La carga se ha reversado exitosamente.", "btn-success")
        )
        .catch( error =>
        {
            console.log(error)            
            vm.openAlertDialog("Ha ocurrido un error al reversar la carga.", "btn-danger")
        })
    }

    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, 
        {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' } }
        })
    }

    pageChanged(event: any) 
    { 
        this.config.currentPage = event 
        
        this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
    }

    cambiaCantidadRegistros()
    {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }
}